import { Cell } from '@/components/ui/shared/Table/Cell';
import { CountCell } from '@/components/ui/shared/Table/cells/CountCell';
import type { HideBelow } from '@/components/ui/shared/Table/types';

export interface TableCountCellProps {
  total: number;
  unread?: number;
  width?: string;
  hideBelow?: HideBelow;
  className?: string;
}

export function TableCountCell({
  total,
  unread,
  width = '110px',
  hideBelow,
  className
}: TableCountCellProps) {
  return (
    <Cell width={width} align="center" hideBelow={hideBelow} className={className}>
      <CountCell total={total} unread={unread} />
    </Cell>
  );
}
